/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  useGetEventActionResourceReportsQuery,
  EventActionResourceReportsFilterInput,
} from "~/generated/graphql";

type Props = {
  eventId: string;
  eventActionId: string;
  page: string;
  limit: string;
  filter?: EventActionResourceReportsFilterInput;
  includeAttempts?: boolean;
};

export function useGetEventActionResourceReports({
  eventId,
  eventActionId,
  page,
  limit,
  filter,
  includeAttempts,
}: Props) {
  const { data, loading, error } = useGetEventActionResourceReportsQuery({
    variables: {
      eventId,
      eventActionId,
      page: Number(page),
      limit: Number(limit),
      filter,
      includeAttempts,
    },
  });

  const count = data?.eventActionResourceReports?.pageInfo?.count ?? 0;

  return {
    data: data?.eventActionResourceReports ?? undefined,
    count,
    loading,
    error,
  } as const;
}
